export default "query getAnagrafiche ($params: ParamsGetAnagrafiche!) {\n    getAnagrafiche(params: $params)\n}";